import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

import { formInputBaseVariants } from "~/components/formElements/formInputBaseVariant.ts";

export const tableFilterSizeVariants = {
	sm: "size-7",
	md: "size-9",
} as const;

export const invoiceStatusFilterButtonVariants = tv({
	slots: {
		button:
			"rounded-button-group-item group relative flex cursor-pointer items-center justify-center ring-1 ring-inset last:rounded-r-md " +
			"bg-white ring-gray-300 hover:bg-gray-200 " +
			formInputBaseVariants.variants.focusRing.true,
	},

	variants: {
		size: {
			sm: {
				button: tableFilterSizeVariants.sm,
			},
			md: {
				button: tableFilterSizeVariants.md,
			},
		},
		checked: {
			true: { button: "bg-opacity-100 hover:bg-opacity-80" },
			false: { button: "bg-opacity-50 hover:bg-opacity-80" },
		},
	},
	defaultVariants: {
		size: "md",
		checked: false,
	},
});

export type InvoiceStatusFilterButtonVariants = VariantProps<typeof invoiceStatusFilterButtonVariants>;
